import { Alert, Button, Typography } from 'antd';
import { observer } from 'mobx-react';
import { ReloadOutlined } from '@ant-design/icons';
import { INewsCategories } from '../../../../store/News/types';

interface NewsCategoryErrorProps {
  controller: INewsCategories;
}

export const NewsCategoryErrorView = observer(
  ({ controller }: NewsCategoryErrorProps) => {
    const message = controller.error;

    if (!message) return null;

    return (
      <Alert
        type="error"
        title={
          <div className="news-categories-alert">
            <div className="news-categories-alert__content">
              <Typography.Text>
                Не удалось получить список разделов новостей
              </Typography.Text>

              <Button
                onClick={controller.load}
                icon={<ReloadOutlined />}
                className="news-categories-alert__button"
              >
                Запросить повторно
              </Button>
            </div>
          </div>
        }
      />
    );
  },
);
